/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Context from "./index";

const ProductProvider = (props) => {
  const [productItem, setProductItem] = useState([]);
  const symbol = "$";
  const [singleItem, setSingleItems] = useState([]);
  const [isVertical, setIsVertical] = useState(false);

  const getSingleItem = () => {
    setSingleItems(productItem[0]);
  };
  useEffect(() => {
    getSingleItem();
  }, [setProductItem]);

  return <Context.Provider value={{ ...props, productItem, singleItem, symbol, isVertical, setIsVertical }}>{props.children}</Context.Provider>;
};

export default ProductProvider;
